import {combineReducers} from "redux";
import { generalStatisticsAllPdfReducer } from './generalStatisticsAllPdfReducer';

export const pdfReportsReducer = combineReducers({
  generalStatistic: generalStatisticsAllPdfReducer
});